import {DropdownOptionProps} from '../../../models/DropdownProps';
import {SELECT_TYPE} from '../../../utils/DropdownOptionPropsUtils';

export const otherFileTypeResource: DropdownOptionProps[] = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    }
];